import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-tenant.dto';
export * from './dtos/tenant-record.dto';
export * from './dtos/tenant-search.dto';
export * from './dtos/tenants-stats.dto';
export * from './dtos/update-tenant.dto';

export * from './enums/tenant-action.enum';
export * from './enums/tenant-status.enum';

export * from './consts/tenant-access-blocking-statuses.const';

export * from './functions/tenant-status-to-color.function';
export * from './functions/is-tenant-access-blocked.function';
export * from './functions/to-internal-tenant-org-id.function';

export * from './types/tenants-filters';

export * from './validators/schemas/create-tenant.schema';
export * from './validators/schemas/update-tenant.schema';

export const tenantValidators = { canCreateOrUpdate, canPerformAction };
